import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
//Redux
import { connect, useDispatch, useSelector } from "react-redux";
import * as questActions from "store/actions/index";
import VideoViewer from "components/Views/ContentViewer/VideoViewer/VideoViewer";
import TpStreamVideoPlayer from "components/CustomComponents/TpStreamVideoPlayer";

// import TopicCards from 'components/Views/Tasks/Topics/TopicCards'
import AutoPlaySwipeableViews from "components/Views/Tasks/Topics/TaskSwipeableViews";
import TopicAccordion from "components/Views/Tasks/Topics/TopicAccordion";

// style
import useStyles from "assets/jss/components/views/topicsContainerStyle";
import { serverDjangoURL } from "variables/ServerURL";
import axiosConfig from "util/axios";

const TaskCard = (props) => {
  const { topics } = props;
  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
      <AutoPlaySwipeableViews
        topics={topics}
        setContentType={props.setContentType}
      />
    </div>
  );
};

function WebTopics(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const elementRef = useRef();

  const mission = useSelector((state) => state.content.current_mission);
  const userInfo = useSelector((state) => state.user.userinfo);
  const [lockDetails, setLockDetails] = useState({
    Watch: true,
    Think: true,
    Solve: true,
    Play: true,
  });
  const quest = useSelector((state) => state.quest.current_quest);
  const content = useSelector((state) => state.content.contentlist);

  const current_content = useSelector((state) => state.content.current_content);

  const operation = useSelector((state) => state.content.current_operation);
  const questContentsList = useSelector((state) =>
    state.content.contentlist.add.questContents.filter(
      (questContent) =>
        operation.operationId === questContent.operationId &&
        questContent["taskId"] === undefined,
    ),
  );
  const taskList = useSelector((state) =>
    state.content.contentlist.add.tasks.filter(
      (task) => operation.operationId === task.operationId,
    ),
  );

  const [isVideo, setIsVideo] = React.useState(false);
  const [ScreenOrientation, setScreenOrientation] = React.useState("portrait");

  const handleChange = (taskId, panel) => (event, newExpanded) => {
    dispatch(questActions.setExpandedFlag(taskId, newExpanded));
  };

  const getContentLockDetails = async () => {
    await axiosConfig(serverDjangoURL)
      .post("api/location/getLocationContentStatus", {
        LocationId: userInfo.locationId,
      })
      .then(async (response) => {
        setLockDetails((prev) => ({ ...prev, ...response?.data?.payload }));
      })
      .catch((error) => {
        if (error.response && error.response.data) {
          throw new Error(error.response.data.error);
        }
        throw new Error(error.message);
      });
  };

  useEffect(() => {
    getContentLockDetails();

    if (questContentsList.length) {
    } else if (taskList.length) {
      dispatch(questActions.setExpandedFlag(taskList[0].taskId, true));
    }

    dispatch(questActions.setCurrentContent({}));
    setIsVideo(false);
  }, [operation.operationId]);

  const handleChangeTask = (contentType) => {
    if (typeof onRemenberMeClicked === "undefined") {
      setIsVideo(contentType);
    } else {
      history.push("/player");
    }

    if (elementRef.current) {
      elementRef.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
  };

  const isNormalVideoContent =
    current_content.contentTypeCode === "01" ||
    current_content.contentTypeCode === "02" ||
    current_content.contentTypeCode === "03";

  const hasTpStreamAsset =
    current_content &&
    current_content.tps_asset_id &&
    String(current_content.tps_asset_id).trim();

  return (
    <div className={classes.root}>
      <div ref={elementRef}>
        {typeof onRemenberMeClicked === "undefined" && isNormalVideoContent ? (
          hasTpStreamAsset ? (
            <TpStreamVideoPlayer
              tps_asset_id={current_content.tps_asset_id}
              title={current_content.contentDisplayName || "TPStream Player"}
              className={classes.videoWrapper}
              key={current_content.tps_asset_id}
            />
          ) : (
            <VideoViewer
              orientation={ScreenOrientation}
              isVideo={isVideo}
              onChangeOrientation={setScreenOrientation}
              isWeb={true}
            />
          )
        ) : null}
      </div>

      <div className={classes.accordionDiv}>
        {questContentsList.length ? (
          <TopicAccordion
            onChange={handleChange("", "panel" + operation.operationId)}
            heading="Introduction"
            lockDetails={lockDetails}
            accordionDetails={
              <TaskCard
                task=""
                topics={questContentsList}
                setContentType={(type) => handleChangeTask(type)}
              />
            }
          />
        ) : null}

        {taskList.length
          ? taskList.map((current_task, indx) => (
              <TopicAccordion
                key={`${current_task.operationId}${current_task.taskId}`}
                onChange={handleChange(
                  current_task.taskId,
                  `${current_task.operationId}${current_task.taskId}`,
                )}
                heading={current_task.taskDisplayName}
                lockDetails={lockDetails}
                accordionDetails={
                  <TaskCard
                    setContentType={(type) => handleChangeTask(type)}
                    key={current_task.taskId}
                    task={current_task}
                    topics={content.add.questContents.filter(
                      (questContent) =>
                        current_task.taskId === questContent.taskId,
                    )}
                  />
                }
              />
            ))
          : null}
      </div>
    </div>
  );
}

export default WebTopics;
